module.exports = __webpack_public_path__ + "static/media/arrow-down.0db11c41.svg";